var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5_5",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5_5",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAB50lEQVRIie2WzS5kQRiG3yKzwLJjhO5ppidWuAlLI5iYBYlbYK7FUmZmIyRi4S/mTiwGIQSx1rPx1x6LUx2ny+mq6mNYeZNO59R3nu+tn+9UlfSuN5KJfREoS5qU9FXSgKSSDZ1LOpG0K2nbGHP2X3oGFIEl4J6wasA6MPBS0yngX4Shqyowkdf0hx1BXtWAhTwjfYlp2jxu5EAJ//QeAGNAF9ADrATMq0BfjPFvT5JbYDCDGQVuPNzPkGkZf/VuedgtD3cPlNLvtzn8pKR2T98OPbG/nli7zd3UeMwDS1LBE/sYYBtyu8aVAPwhZ0ySvviMewNwH/BsKWxbMcQ2jdjSD2k6g/sewVV9xvsRCY6AQoop2LaQGorPnerjwHRJSR2MpJ5HFK4NSTryGf+JSHAqaS/1vCcp5ihsnhv4RPYGcgOskuzhHRlcB/DNvnObwd/hbCBZ5r8c6AIYihhRnR8GLp0cSzFgkcbqbvlctTNT1xXw7DN111jGmAtJc5IebFN/q8aSyvb/QdKcMeYymgQWeDqTN0juXCGmH9i0TA2Yz9FpCZhITfs1sAbMABWg0/4qwCzJXat+NF4B47lMU+bdwKKtzJBqwHLWmrpq5Xpb0tP19rMar7fHSr7THWPMeevDe9cr6hHMeNzkkdqENgAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon__profile.ca7bce7f3ef584eb6ffad53043f4790a.svg";
export { ForwardRef as ReactComponent };